import { Component, inject, OnInit } from '@angular/core'
import { Card } from 'primeng/card'
import { Router } from '@angular/router'
import { LdapManagerService } from '../../../core/services/ldap-manager.service'
import { SessionService } from '../../../core/security/session.service'
import { GatewayError } from '../../../models/gateway.model'
import { User } from '../../../models/user.model'
import { Message } from 'primeng/message'
import { LoggerService } from '@danangelus/ngx-app-core'

const log = LoggerService.get("ManageAccountComponent")

@Component({
    selector: 'app-manage-mfa',
    standalone: true,
    imports: [
        Card,
        Message
    ],
    templateUrl: './manage-account.component.html',
    styleUrl: './manage-mfa.component.sass'
})
export class ManageAccountComponent implements OnInit {

    private ldapManager = inject(LdapManagerService)
    private router = inject(Router)
    private sessionService = inject(SessionService)

    defaultMfa: string | undefined
    defaultSet = false
    error = false
    // @ts-expect-error ngOnInit
    user: User | null

    async ngOnInit() {
        this.user = await this.sessionService.getUser()
        const response = await this.ldapManager.getDefaultMfaOption(this.user!.userId!)
        if (response instanceof GatewayError) {
            throw GatewayError
        }
        this.defaultMfa = response
    }

    async manageApp() {
        log.info('manageApp', 'Redirecting to App-auth setup')
        this.error = false
        await this.router.navigate(['/account/enroll-app-mfa'])
    }

    async manageEmail() {
        log.info('manageEmail', 'Setting default MFA option as "email"')
        this.error = false
        const defaultSet = await this.ldapManager.setDefaultMfaOption(this.user!.userId!, 'email')

        if (defaultSet instanceof GatewayError) {
            this.error = true
        } else {
            const response = await this.sessionService.loadSession()
            if (response instanceof User) {
                this.user = response
                this.sessionService.userVerified(new User(response))
                this.defaultSet = true
                setTimeout(async () => {
                    await this.router.navigate(['/home'])
                }, 2000)

            } else {
                this.error = true
            }
        }
    }

    async manageSms() {
        log.info('manageSms', 'Setting default MFA option as "sms"')
        await this.router.navigate(['/account/enroll-sms-mfa'])
    }
}
